module.exports = __webpack_public_path__ + "img/leaf.043db5e5.svg";